export const WHITESPACE_REGEX: RegExp = /\s+/;
